import { defineStore } from 'pinia'

export const useNewsStore = defineStore('newsStore', {
  state: () => ({
    fetched_on: null,
    articles: null,
  }),
  persistedState: {
    persist: true,
  },
})
